// @flow

import {Tag} from 'docs/util';

import type {MarkdocFragmentRegistration} from 'docs/markdoc';

export const Edge: MarkdocFragmentRegistration = {
  tag: 'edge',
  attributes: {
    from: {
      type: String,
      required: true,
      description: 'The node ID to draw this edge from',
    },
    to: {
      type: String,
      required: true,
      description: 'The node ID to draw this edge to',
    },
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);
    return new Tag('edge', attributes, children);
  },
};
